<script setup>
import { ref } from "vue";

const modalTitle = ref("");
const modalContent = ref("");
const showModal = ref(false);

const openInfoModal = (title, content) => {
	modalTitle.value = title;
	modalContent.value = content;
	showModal.value = true;
};

defineExpose({
	openInfoModal,
});
</script>

<template>
	<div
		v-if="showModal"
		class="modal fade modal-info show"
		style="display: block"
		tabindex="-1"
	>
		<div class="modal-dialog modal-xl modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header border-0 px-5 py-4">
					<h4 class="modal-title">
						{{ modalTitle }}
					</h4>
					<button
						type="button"
						class="btn-close"
						@click="showModal = false"
					></button>
				</div>
				<div class="modal-body px-5" v-html="modalContent"></div>
				<div class="modal-footer border-0 px-5 pt-0">
					<button
						type="button"
						class="btn btn-rounded btn-blue"
						data-bs-dismiss="modal"
						@click="showModal = false"
					>
						<span>Close</span>
						<i class="ri ri-close-fill"></i>
					</button>
				</div>
			</div>
		</div>
	</div>
	<div v-if="showModal" class="modal-backdrop fade show"></div>
</template>
